module.exports = __webpack_public_path__ + "img/saba.7a9ccb6e.png";